<script>
import { apiMixins } from "../../mixins/api.js";

export default {
  props: {
    item: {
      type: Object,
      required: false,
    },
    availableRetentionSchedules: {
      type: Array,
      required: true
    },
    currentRetentionSchedule: {
      type: String,
      required: false,
    }
  },
  mixins: [apiMixins],
  emits: ["retention-schedule-changed"],
  data() {
    return {
      workingRetentionSchedule: null,
      selectedRetentionSchedule: null,
      workingRegion: "default",
      workingRetentionScheduleId: null,
      parsedItemSchedule: this.item && this.item.retSchedule && this.item.retSchedule.replace("#", ""),
    };
  },
  computed: {
    filteredRetentionSchedules() {
      const region = (this.workingRegion || "").toLowerCase();
      if (region) {
        return this.availableRetentionSchedules.filter(
          (r) => (r.region || "default").toLowerCase() === region
        );
      }
      return this.availableRetentionSchedules;
    },
  },
  methods: {
    onRegionChangedHandler() {
      this.workingRegion = null;
    },
    onRetentionScheduleChanged(event) {
      const selectedId = event?.target?.value ?? event?.value ?? "";
      this.selectedRetentionSchedule = this.availableRetentionSchedules.find(r => r.id === selectedId);
      this.$emit("retention-schedule-changed", this.selectedRetentionSchedule);
    },
    isCurrentItemRetentionScheduleEmpty() {
      return !this.currentRetentionSchedule;
    }
  },
  mounted() {
    if (!this.isCurrentItemRetentionScheduleEmpty()) {
      this.workingRetentionSchedule = this.availableRetentionSchedules.find(r => r.id === this.currentRetentionSchedule);
    }
    if (this.workingRetentionSchedule) {
        this.workingRegion = (this.workingRetentionSchedule.region || "default").toLowerCase();
        this.workingRetentionScheduleId = this.workingRetentionSchedule.id;
    } else {
      this.workingRegion = "default";
    }
  },
};
</script>

<template>
  <div class="retention-picker">
    <label>
      <span>{{ $t("retention-schedule-picker.region-label") }}</span>
      <select
        id="select-retention-schedule-region"
        v-model="workingRegion"
        class="retention-select"
      >
        <option value="default">Default Region</option>
        <option value="svk">SVK Region</option>
      </select>
    </label>
    <label>
      <span>{{ $t("retention-schedule-picker.schedule-label") }}</span>
      <select
        id="select-retention-schedule"
        v-model="workingRetentionScheduleId"
        class="retention-select"
        @change="onRetentionScheduleChanged"
      >
        <option value="">{{ $t("retention-schedule-picker.default-schedule-option") }}</option>
        <option
          v-for="schedule in filteredRetentionSchedules"
          :key="schedule.id"
          :value="schedule.id"
          :selected="schedule.id === workingRetentionScheduleId"
          >{{ schedule.id }}: - {{ schedule.title }} ({{
            schedule.period
          }})</option
        >
      </select>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.retention-picker {
  display: grid;
  gap: 1rem;
  grid-template-columns: 14rem minmax(0, 1fr);
  min-width: 32rem;

  label {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;

    span {
      color: #333;
      font-weight: bold;
    }
  }
}

.retention-select {
  background: white;
  border: 1px solid #CFCFCF;
  border-radius: 4px;
  box-sizing: border-box;
  color: #111;
  font: inherit;
  min-height: 2.5rem;
  padding: 0.55rem 0.65rem;
  width: 100%;
}

@media (max-width: 720px) {
  .retention-picker {
    grid-template-columns: 1fr;
    min-width: 0;
  }
}

</style>
